// Bridge to the native Android app.
//
// The `Android` object is injected into the WebView by the app itself, so it
// only exists when these pages run inside the app. Sniffing the user agent is
// not enough: a browser with an Android user agent (device emulation, or an
// Android UA set on an iframe) passes that check while the object is still
// undefined, which is where `ReferenceError: Android is not defined` came from.
//
// Always call through these helpers rather than touching the global directly —
// they no-op outside the app, so the same page keeps working in a plain browser.

function bridge(method) {
  const android = typeof window !== 'undefined' ? window.Android : undefined;
  return android && typeof android[method] === 'function' ? android : null;
}

export function viewClose(status = '') {
  const android = bridge('viewClose');
  if (android) android.viewClose(status);
}

export function redirectProfile(url) {
  const android = bridge('redirectProfile');
  if (android) android.redirectProfile(url);
}
